<template>
  <div
    class="flex-box-center-items-vertical poll-input-form"
    :class="{ 'poll-input-form--row': $vuetify.breakpoint.smAndDown }"
    style="align-items: center"
  >
    <template v-if="!isTransportUsageInPercentage()">
      <div
        style="height: 100%; width: 100%"
        class="flex-box-center-items-horizontal"
      >
        <span>Tage pro Woche</span>
        <v-tooltip top>
          <template v-slot:activator="{on, attrs}"
            ><v-icon
              :color="$vuetify.theme.themes.light.secondary"
              size="dense"
              dark
              v-bind="attrs"
              v-on="on"
              >mdi-help-circle</v-icon
            ></template
          >
          <span
            >An wie vielen Tagen pro Woche nutzen Sie diese Variante für Ihren
            Arbeitsweg?</span
          >
        </v-tooltip>
      </div>
      <div
        style="height: 100%; width: 100%"
        class="flex-box-center-items-horizontal"
      >
        <v-btn
          @click="decrementPollFrequency(transportId)"
          style="
            min-width: 20%;
            padding: 0 3px;
            height: 100%;
            align-items: center;
          "
        >
          <v-icon> remove </v-icon>
        </v-btn>
        <input
          type="text"
          outlined
          @change="pollFrequencyChanged(transportId, $event)"
          :value="getPollFreq(transportId)"
          style="height: 100%; min-width: 60%; text-align: center"
          :style="colorOfInputElementsStyle"
        />
        <v-btn
          @click="incrementPollFrequency(transportId)"
          style="
            min-width: 20%;
            padding: 0 3px;
            height: 100%;
            text-align: center;
          "
        >
          <v-icon> add </v-icon>
        </v-btn>
      </div>
    </template>
    <template v-else>
      <div
        style="height: 100%; width: 100%"
        class="flex-box-center-items-horizontal"
      >
        <span>Anteil pro Jahr (in %)</span>
      </div>
      <div
        style="height: 100%; width: 100%"
        class="flex-box-center-items-horizontal"
      >
        <input
          type="text"
          outlined
          @change="pollFrequencyChanged(transportId, $event)"
          :value="getPollFreq(transportId)"
          style="height: 100%; min-width: 60%; text-align: center"
          :style="colorOfInputElementsStyle"
        />
      </div>
      <span v-if="!isPercentageValid(transportId)" style="color: red">Eintrag ungültig!</span>
    </template>

    <span v-if="transportMode == 'car'" style="align-self: center"
      >Personen im Pkw</span
    >

    <div
      v-if="transportMode == 'car'"
      style="height: 100%; width: 100%"
      class="flex-box-center-items-horizontal"
    >
      <v-btn
        @click="decrementPassengers(transportId)"
        style="
          min-width: 20%;
          padding: 0 3px;
          height: 100%;
          align-items: center;
        "
      >
        <v-icon> remove </v-icon>
      </v-btn>
      <input
        type="text"
        outlined
        @change="nPassengersChanged(transportId, $event)"
        :value="getNumberPassengers(transportId)"
        style="height: 100%; min-width: 60%; text-align: center"
        :style="colorOfInputElementsStyle"
      />
      <v-btn
        @click="incrementPassengers(transportId)"
        style="min-width: 20%; padding: 0 3px; height: 100%; text-align: center"
      >
        <v-icon> add </v-icon>
      </v-btn>
      <!-- </div> -->
    </div>
    <span style="align-self: center">Bewertung (1–5 Sterne)</span>
    <PollRating
      :transportId="transportId"
      :config="config"
      :routes="routes"
    ></PollRating>
    <span
      v-if="isMissingRating(transportId)"
      class="poll-missing-rating"
      role="status"
      >Bitte bewerten</span
    >
    <!-- <div class="flex-box-left-aligned-horizontal">
    
    <v-tooltip top>
      <template v-slot:activator="{on, attrs}"
        ><div  v-bind="attrs" v-on="on"
          >
        <v-rating
        v-bind="attrs"
          v-on="on"
      :background-color="$vuetify.theme.themes.light.secondary"
      :color="$vuetify.theme.themes.light.secondary"
      :size="isSmallScreenWidth() ? '15' : '25'"
    >my rating</v-rating></div>
        </template
      >
      <span>Wie findest du diese Fahrtvariante? </span>

    
    </v-tooltip> 
   
  </div> -->
  </div>
</template>

<script>
import {storeToRefs} from "pinia";
import Vue from "vue";
import {usePollStore} from "../../store/poll-store";
import * as utils from "../../utils";
import PollRating from "./PollRating.vue";

export default Vue.extend({
  name: "PollCompanyInputForm",

  components: {
    PollRating,
  },

  props: {
    transportId: {type: String, default: ""},
    config: {type: Object, default: undefined},
    transportMode: {type: String, default: ""},
    routes: {type: Array, default: () => []},
  },

  data: () => ({}),

  mounted() {},

  methods: {
    isTransportUsageInPercentage() {
      const frequencyType = storeToRefs(usePollStore()).frequencyType.value;
      switch (frequencyType) {
        case "percentage":
          return true;
        case "days":
          return false;
        default:
          return false;
      }
    },
    isMissingRating(transportId) {
      return usePollStore().isTransportMissingRating(transportId);
    },
    isPercentageValid(transportId) {
      return usePollStore().pollFrequency(transportId) >=0  && usePollStore().pollFrequency(transportId) <= 100;
    },
    isSmallScreenWidth() {
      return window.innerWidth < 700;
    },
    incrementPollFrequency(transportId) {
      // this.pollFrequencies[transportId].freq += 1;
      usePollStore().incrementFrequency(transportId);
    },
    decrementPollFrequency(transportId) {
      // if (this.pollFrequencies[i].freq > 0) {
      //   this.pollFrequencies[i].freq -= 1;
      // }
      usePollStore().decrementFrequency(transportId);
    },
    pollFrequencyChanged(transportId, event) {
      let val = event.target?.value;
      const num = Number(val);
      usePollStore().setFrequency(num, transportId);
      // this.pollFrequencies[i].freq = num;
    },
    getPollFreq(transportId) {
      return usePollStore().pollFrequency(transportId);
      // if (this.pollFrequencies.length - 1 >= i) {
      //   return this.pollFrequencies[i].freq;
      // } else {
      //   return 0;
      // }
    },
    incrementPassengers(transportId) {
      usePollStore().incrementNumberPassengers(transportId);

      // this.numberPassengers[i].freq += 1;
    },
    decrementPassengers(transportId) {
      // if (this.numberPassengers[i].freq > 0) {
      //   this.numberPassengers[i].freq -= 1;
      // }
      usePollStore().decrementNumberPassengers(transportId);
    },
    nPassengersChanged(transportId, event) {
      let val = event.target?.value;
      const num = Number(val);
      usePollStore().setNumberPassengers(num, transportId);
      // this.numberPassengers[transportId].freq = num;
    },
    getNumberPassengers(transportId) {
      return usePollStore().numberPassengersOfTransport(transportId);
      // if (this.numberPassengers.length - 1 >= i) {
      //   return this.numberPassengers[i].freq;
      // } else {
      //   return 0;
      // }
    },
  },

  computed: {
    colorOfInputElementsStyle() {
      return utils.colorOfInputElementsStyle.bind(this)();
    },
  },

  watch: {
    routes: {
      handler: function (o, n) {
        this.lastUpdated = Date.now();
        const frequencies = storeToRefs(usePollStore()).frequencies.value;
        // init poll frequencies
        this.routes.forEach((r, i) => {
          if (
            !frequencies.find(
              (poll) => poll.transportId === r.transport.id
            )
          ) {
            usePollStore().addNumberPassengers({
              freq: 0,
              transportId: r.transport.id,
            });
            usePollStore().addFrequency({freq: 0, transportId: r.transport.id});
          }
        });
      },
      deep: true,
      immediate: true,
    },
  },
});
</script>

<style scoped>
.full-width {
  width: 100%;
}
/* small screens: the form sits below the transport card, so lay the groups out side by side */
.poll-input-form--row {
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  column-gap: 16px;
  row-gap: 4px;
  padding: 4px 0 8px 0;
  background-color: white;
  border-radius: 0 0 8px 8px;
}
.poll-input-form--row > div {
  width: auto !important;
  min-width: 150px;
}
.poll-input-form--row > div > input {
  min-width: 50px !important;
  width: 50px;
}
.poll-missing-rating {
  color: #b00020;
  font-weight: 500;
  align-self: center;
}
.sort-btns >>> button:not(.v-btn--active),
.sort-btns >>> i,
button {
  color: #333 !important;
}
.background-white {
  background-color: white;
}
.padding-10px {
  padding: 10px;
}
.border-radius-10px {
  border-radius: 10px;
}
.flex-box-centered-horizontal {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.cursor-pointer {
  cursor: pointer;
}
.font-size-22px {
  font-size: 22px;
}
.margin-left-15px {
  margin-left: 15px;
}
</style>
